// extracted by mini-css-extract-plugin
export default {"container":"userDetail_container__g0Q3m","info__box":"userDetail_info__box__RcFJH","title":"userDetail_title__htlvL"};